import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutFormsInpuRowl: FunctionComponent<Props> = ({ children, className, error, errorMessage }) => {
    return (
        <StyledComponent
            className={classnames(
                'layout-forms-input-row',
                { error },
                className,
            )}
        >
            {errorMessage && (<span className="input-row-error">{errorMessage}</span>)}
            {children}
        </StyledComponent>
    );
};

export default LayoutFormsInpuRowl;